import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Row, Col, Container, Alert } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import ContratoService from '../../../../../services/contrato-auth';



const FormArquivo = () => {
    const [anexos, setAnexos] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [ano, setAno] = useState("");
    const [processo, setProcesso] = useState("");




    const handleUpload = (event) => {
        const files = event.target.files;
        setAnexos(files);
    };

    async function pegaAno(id) {
        const response = await ContratoService.contratoEdit(id);
        setAno(response.data["anoProcesso"]);
        setProcesso(response.data["processo"]);
    }

    useEffect(() => {
        pegaAno(id)
    }, [])

    const { id } = useParams();
    const montaForm = async () => {
        const lic = new FormData();
        lic.append("ano", ano);
        lic.append("processo", processo);
        for (let i = 0; i < anexos.length; i++) {
            lic.append('anexos', anexos[i]);
        }
        return lic
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const contrato = await ContratoService.termo(id, dados)
                setSucesso(true)
                setError(false)
        } catch (error) {
            setError(error)
        }
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col lg={12}>
                                    <Form.Group className="mb-3" controlId="termoAditivo">
                                        <Form.Label>Termo(s) Aditivo(s)</Form.Label>
                                        <Form.Control
                                            required
                                            type="file"
                                            name="documentos"
                                            onChange={handleUpload}
                                            accept=".pdf, .xlsx., xls"
                                            multiple // Permite múltiplos arquivos
                                        />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <br />
                        <Link to={`/restrito/contratos/listar`}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Contrato editado com sucesso!</Alert>
                <Link to={`/restrito/contratos/listar`}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Contratos
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default FormArquivo